<template>
    <div class="accountInfo">
        <div class="uTitle"><h3>账号信息</h3><span>账号信息不与简历信息同步</span></div>
        <div class="acMainCont" v-if="!editStatus">
            <el-form label-width="92px" class="accountInfoForm">
                <el-form-item label="用户名">
                    <span>{{accountInfo.username}}</span>
                </el-form-item>
                <el-form-item label="性别">
                    <span v-if="accountInfo.gender===0">男</span>
                    <span v-if="accountInfo.gender===1">女</span>
                </el-form-item>
                <el-form-item label="邮箱">
                    <span>{{accountInfo.email}}</span>
                </el-form-item>
                <el-form-item label="密码">
                    <span>**********</span>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="enterEditor">编辑</el-button>
                    <!--<el-button type="primary" @click="handleUpdatePassword">点击更改密码</el-button>-->
                </el-form-item>
            </el-form>
            <div class="userIcon">
                <el-avatar v-if="accountInfo.avatar" :src="accountInfo.avatar" ></el-avatar>
                <img v-else src="@/pages/frontend/assets/images/defaultHeadIcons.png">
                <!--<el-button type="text" class="userIconEdit" icon="el-icon-camera" title="修改头像"></el-button>-->
            </div>
            <!--<div class="userIcon"><img src="@/pages/frontend/assets/images/headIcons.png"></div>-->
        </div>


        <div class="acMainCont" v-if="editStatus">
            <el-form ref="accountInfoForm" :model="accountInfoForm" label-width="92px" class="accountInfoForm">
                <el-form-item label="用户名" prop="username">
                    <el-input v-model="accountInfoForm.username"></el-input>
                </el-form-item>
                <el-form-item label="性别" prop="gender">
                    <el-radio-group v-model="accountInfoForm.gender" size="medium">
                        <el-radio border :label="0" >男</el-radio>
                        <el-radio border :label="1" >女</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="邮箱" prop="email">
                    <el-input v-model.number="accountInfoForm.email" disabled></el-input>
                </el-form-item>
                <el-form-item label="密码" prop="password">
                    <el-button type="text" @click="handleUpdatePassword">点击更改密码</el-button>
                    <!--<el-input type="password" v-model="accountInfoForm.password" autocomplete="off"></el-input>-->
                </el-form-item>
                <!-- <el-form-item label="确认密码" prop="checkPass">
                    <el-input type="password" v-model="accountInfoForm.checkPass" autocomplete="off"></el-input>
                </el-form-item> -->
                <el-form-item style="display: none;">
                    <label for="avatar">
                        <input id="avatar" type="file" style="display: none;" @change="uploadImg" accept="image/jpg,image/jpeg,image/png,image/bmp">
                        <!--<el-avatar :src="accountInfoForm.avatar" ></el-avatar>-->
                    </label>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="updateUserInfo()">保存</el-button>
                    <el-button @click="exitEdit">取消</el-button>
                </el-form-item>
            </el-form>
            <div class="userIcon">
                <!--<img src="@/pages/frontend/assets/images/headIcons.png">-->
                <el-avatar v-if="accountInfoForm.avatar" :src="accountInfoForm.avatar" ></el-avatar>
                <img v-else src="@/pages/frontend/assets/images/defaultHeadIcons.png">
                <el-button type="text" class="userIconEdit" icon="el-icon-camera" title="修改头像" @click="selectAvatar"></el-button>
            </div>
        </div>

        <el-dialog title="更改密码" :visible.sync="updatePasswordDialog" width="460px" heigth="240px" :before-close="closePasswordDialog">
            <el-form ref="passForm" :model="passForm" :rules="rules" label-width="80px">
                <el-form-item label="当前账号">
                    <div class="sub-title">{{passForm.username}}</div>
                </el-form-item>
                <el-form-item label="当前密码" prop="originPwd">
                    <el-input v-model.trim="passForm.originPwd" placeholder="请输入当前密码" show-password/>
                </el-form-item>
                <el-form-item label="新密码" prop="newPwd">
                    <el-input v-model="passForm.newPwd" placeholder="请输入新密码" show-password/>
                </el-form-item>
                <el-form-item label="确认密码" prop="confirmPwd">
                    <el-input v-model.trim="passForm.confirmPwd" placeholder="请确认密码" show-password/>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="savePasswordDialog">保 存</el-button>
                <el-button @click="closePasswordDialog">取 消</el-button>
            </div>
        </el-dialog>

        <el-dialog title="图片裁剪" width="38%" :visible.sync="cropper.choose" append-to-body :show-close="false" :close-on-click-modal='false'>
            <div style="height: 350px;">
                <vueCropper
                        ref="cropper"
                        :img="cropper.src"
                        :outputType="cropper.outputType"
                        :outputSize="cropper.outputSize"
                        :canMoveBox="cropper.canMoveBox"
                        :fixedBox="cropper.fixedBox"
                        :autoCrop="cropper.autoCrop"
                        :centerBox="cropper.centerBox"
                        :autoCropWidth="cropper.autoCropWidth"
                        :autoCropHeight="cropper.autoCropHeight"
                        :fixed="cropper.fixed"
                        :fixedNumber="cropper.fixedNumber"
                ></vueCropper>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cropper.choose=false">取 消</el-button>
                <el-button type="primary" @click="cutCover">确 定</el-button>
            </div>
        </el-dialog>


    </div>
</template>
<script>
    import {updatePassword,getLoginUserInfo,updateUserInfo} from '@/api/user'
    import {VueCropper} from 'vue-cropper';
    export default {
        name: 'account',
        data() {
            var pattern = /(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z]).{8,16}/;
            var validateOriginPwd = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入密码'));
                }else if(value.length < 8 || value.length > 100 || !pattern.test(value)){
                    callback(new Error('密码为8-16个字符，至少1个大写字母，1个小写字母和1个数字'));
                } else {
                    callback();
                }
            };
            var validateNewPwd = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入密码'));
                }else if(value.length < 8 || value.length > 100 || !pattern.test(value)){
                    callback(new Error('密码为8-16个字符，至少1个大写字母，1个小写字母和1个数字'));
                } else {
                    if (this.passForm.confirmPwd !== '') {
                        this.$refs.passForm.validateField('confirmPwd');
                    }
                    callback();
                }
            };
            var validateConfirmPwd = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请再次输入密码'));
                }else if(value.length < 8 || value.length > 100 || !pattern.test(value)){
                    callback(new Error('密码为8-16个字符，至少1个大写字母，1个小写字母和1个数字'));
                } else if (value !== this.passForm.newPwd) {
                    callback(new Error('两次输入密码不一致!'));
                } else {
                    callback();
                }
            };
            return {
                editStatus: false,
                accountInfoForm: {
                    userId: '',
                    username: '',
                    password: '',
                    gender: '',
                    avatar: '',
                    accessToken: '',
                },
                accountInfo:{},
                cropper: {
                    choose: false,
                    src: null,
                    outputType: "jpg", //裁剪生成图片的格式
                    outputSize: 0.8, //裁剪生成图片的质量
                    canMoveBox: false, //截图框能否拖动
                    fixedBox: false, //固定截图框大小 不允许改变
                    centerBox: true, //截图框是否被限制在图片里面
                    autoCrop: true, //是否默认生成截图框
                    autoCropWidth: 480, //默认生成截图框宽度
                    autoCropHeight: 480, //默认生成截图框高度
                    fixed: true,
                    fixedNumber: [1, 1], //截图框的宽高比例
                    data: null,
                },


                token:undefined,
                updatePasswordDialog: false,
                passForm: {
                    username:'',
                    originPwd:'',
                    newPwd:'',
                    confirmPwd:''
                },
                rules: {
                    originPwd: [
                        { validator: validateOriginPwd, trigger: 'blur' }
                    ],
                    newPwd: [
                        { validator: validateNewPwd, trigger: 'blur' }
                    ],
                    confirmPwd: [
                        { validator: validateConfirmPwd, trigger: 'blur' }
                    ]
                }
            }
        },
        created(){
            this.getLoginUserInfo()
            this.getUserInfo();
        },
        methods: {
            /** 进入编辑状态*/
            enterEditor(){
                this.editStatus = true;
            },
            /** 退出编辑状态*/
            exitEdit(){
                this.editStatus = false;
            },
            /** 点击弹出图片文件选择框*/
            selectAvatar(){
                document.getElementById("avatar").click();
            },
            getUserInfo() {
                getLoginUserInfo().then(res => {
                    this.accountInfoForm = res.data;
                    this.accountInfo = Object.assign({}, this.accountInfoForm);
                })
            },
            updateUserInfo(){
                updateUserInfo(this.accountInfoForm).then(res=>{
                    this.accountInfo = Object.assign({}, this.accountInfoForm);
                    this.exitEdit();
                })
            },
            // 获取截图的base64 数据
            cutCover(){
                this.$refs.cropper.getCropData((data) => {
                    this.accountInfoForm.avatar = data;
                    this.cropper.choose = false;
                })
            },
            uploadImg(event){
                let file = event.target.files[0];
                const maxSize = 1024 * 1024 * 10;
                if (file) {
                    if (file.size > maxSize){
                        this.$message.error("图片大小不可超过10MB");
                        return false;
                    }else {
                        let $this = this;
                        let reader = new FileReader();
                        reader.onload = function (event) {
                            let raw = event.target.result;
                            $this.cropper.src = raw;
                        };
                        reader.readAsDataURL(file);
                        this.cropper.choose = true;
                    }
                } else {
                    this.cropper.choose = false;
                }
            },
            deepCopy(source) {//深度拷贝，返回新对象
                let result;
                (source instanceof Array) ? (result = []) : (result = {});
                for (let key in source) {
                    result[key] = typeof source[key] === 'Array' ? this.deepCopy(source[key]) : source[key];
                }
                return result;
            },

            getLoginUserInfo(){
                this.passForm.username = window.localStorage.getItem("username");
                let loginUserInfo = window.localStorage.getItem("loginUserInfo");
                if(loginUserInfo){
                    this.token = JSON.parse(loginUserInfo).accessToken
                }
            },
            handleUpdatePassword(){
                this.updatePasswordDialog = true;
            },
            savePasswordDialog(){
                this.$refs["passForm"].validate((valid) => {
                    if (valid && this.token) {
                        updatePassword(this.token,this.passForm).then((res)=>{
                            if(res && res.status == 200){
                                this.msgSuccess(res.data);
                                // 关闭窗口
                                this.closePasswordDialog()
                            }else{
                                this.msgError(res.data);
                            }
                        });
                    }else{
                        this.msgError("填写的数据有误，请检查！");
                    }
                })
            },
            closePasswordDialog(){
                this.$refs["passForm"].resetFields();
                this.updatePasswordDialog = false;
            },
        },
        components: {
            VueCropper
        },
    }
</script>